import Vue from 'vue';
import Router from 'vue-router';
import store from '@/config/store';

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login/Login'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login/Login'),
    },
    {
      path: '/registration-status',
      name: 'registration status',
      component: () => import(/* webpackChunkName: "registrationstatus" */ '@/views/RegistrationStatus/RegistrationStatus'),
    },
    {
      path: '/library-registration',
      name: 'library registration',
      component: () => import(/* webpackChunkName: "libraryregistration" */ '@/views/LibraryRegistration/LibraryRegistration'),
    },
    {
      path: '/uitschrijven',
      name: 'unsubscribe',
      component: () => import(/* webpackChunkName: "unsubscribe" */ '@/views/Unsubscribe/Unsubscribe'),
    },
    {
      path: '/ouder-landing',
      name: 'confirmation page',
      component: () => import(/* webpackChunkName: "confirmationpage" */ '@/views/ConfirmationPage/ConfirmationPage'),
    },
  ],
});

export default router;
